<!-- Navbar -->
<app-navbar-control></app-navbar-control>

<div class="contact-us-details">
  <div class="container">

    <div class="row justify-content-center">
      <div class="col-lg-8">

        <div class="contact-header text-center">
          <span class="section-badge">
            {{'Contact_Us' | translate}}
          </span>

          <h1 class="contact-title">
            We'd Love to Hear From You
          </h1>

          <p class="contact-subtitle">
            {{'Wed_love' | translate}}
          </p>
        </div>

        <div class="contact-card">
          <form autocomplete="off" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
            <!-- Full Name and Email -->
            <div class="row">
              <div class="col-6 mb-3">
                <label for="name" class="form-label">{{'Full_Name' | translate}}</label>
                <input type="text" id="name" class="form-control" formControlName="name" required>
                @if (contactForm.get('name')?.invalid && contactForm.get('name')?.touched) {
                <div class="text-danger">{{'Name_is_required' | translate}}</div>
                }
              </div>
              <div class="col-6 mb-3">
                <label for="email" class="form-label">{{'Email' | translate}}</label>
                <input type="email" id="email" class="form-control" formControlName="email" required>
                @if (contactForm.get('email')?.invalid && contactForm.get('email')?.touched) {
                <div class="text-danger">{{'Valid_email_is_required' | translate}}</div>
                }
              </div>
            </div>

            <!-- Phone, Subject, and Message -->
            <div class="row">
              <div class="col-6 mb-3">
                <label for="phone" class="form-label">{{'Phone' | translate}}</label>
                <input type="tel" id="phone" class="form-control" formControlName="phone" pattern="[0-9]{10}" required>
                <small class="text-muted">{{'10_digit_number' | translate}}</small>
                @if (contactForm.get('phone')?.invalid && contactForm.get('phone')?.touched) {
                <div class="text-danger">{{'Valid_phone_is_required' | translate}}</div>
                }
              </div>
              <div class="col-6 mb-3">
                <label for="subject" class="form-label">{{'Subject' | translate}}</label>
                <input type="text" id="subject" class="form-control" formControlName="subject" required>
                @if (contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched) {
                <div class="text-danger">{{'subject_is_required' | translate}}</div>
                }
              </div>
            </div>

            <div class="mb-3">
              <label for="message" class="form-label">{{'Message' | translate}}</label>
              <textarea id="message" class="form-control" formControlName="message" rows="3" required></textarea>
              @if (contactForm.get('message')?.invalid && contactForm.get('message')?.touched) {
              <div class="text-danger">{{'Message_is_required' | translate}}</div>
              }

            </div>
            <!-- Submit Button -->
            <button type="submit" class="btn btn-dark btn-sm w-100" [disabled]="contactForm.invalid">{{'Send_Message' |
              translate}}</button>
          </form>
          <!-- Your existing form here unchanged -->
        </div>

      </div>
    </div>

  </div>
</div>